import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260722_tall_cabinet_filler_panel_settings",
  description: "Backfill tallCabinetDepth and tallCabinetMaterial on existing CASEWORK_SETTINGS",
  apply(json: any) {
    const settingsTable = json.settings ?? {};

    for (const setting of Object.values(settingsTable) as any[]) {
      if (setting?.type !== "CASEWORK_SETTINGS") {
        continue;
      }

      if (setting.tallCabinetDepth === undefined) {
        setting.tallCabinetDepth = 24;
      }

      if (setting.tallCabinetMaterial === undefined) {
        setting.tallCabinetMaterial = "propDefault0";
      }
    }

    return json;
  },
};

export default migration;
